import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '../auth.service';
import { CompleteProfileService } from '../complete-profile/complete-profile.service';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

export const profileCompleteGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const completeProfileService = inject(CompleteProfileService);

  return authService.getProfile().pipe(
    map((profile) => {
      if (profile.profileComplete === false) {
        completeProfileService.open({
          userType: profile.roles?.includes('student') ? 'student' : 'teacher',
          redirectUrl: state.url,
        });
      }
      return true;
    }),
    catchError(() => of(true)),
  );
};
